webpackJsonp([61],{

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverJob_vue__ = __webpack_require__(736);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418a4789_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverJob_vue__ = __webpack_require__(917);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverJob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418a4789_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverJob_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["id", "header", "content", "closeIcon", "cancelLabel", "submitLabel", "color", "icon", "subContent", "modalSize"],
  computed: {
    hasCloseIcon: function hasCloseIcon() {
      return this.closeIcon && this.closeIcon === true ? true : false;
    },
    hasCancel: function hasCancel() {
      return this.cancelLabel && this.cancelLabel !== "";
    },
    hasSubmit: function hasSubmit() {
      return this.submitLabel && this.submitLabel !== "";
    },
    getId: function getId() {
      return this.id && this.id !== "" ? this.id : "confirmmodal";
    },
    getColor: function getColor() {
      return this.color && this.color !== "" ? this.color : "confirm-icon";
    },
    getIcon: function getIcon() {
      return this.icon && this.icon !== "" ? this.icon : "ic-check";
    }
  },
  methods: {
    closeModal: function closeModal() {
      $("#" + this.getId).modal("hide");
    },
    cancel: function cancel() {
      this.$emit("onCancel");
    },
    submit: function submit() {
      $("#" + this.getId).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__ = __webpack_require__(518);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af674af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("5636d7fe", content, true, {});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".note-content[data-v-6af674af]{font-size:13px;color:#999}.modal-header-confirm[data-v-6af674af]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:15px}", "", {"version":3,"sources":["/app/src/components/shared/ConfirmModal.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,UAAY,CACb,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,YAAc,CACf","file":"ConfirmModal.vue","sourcesContent":["\n.note-content[data-v-6af674af] {\n  font-size: 13px;\n  color: #999;\n}\n.modal-header-confirm[data-v-6af674af] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.getId}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalSize === 'modal-sm' ? 'modal-sm' : 'modal-xs'},[_c('div',{staticClass:"modal-content"},[(_vm.hasCloseIcon)?_c('div',{staticClass:"modal-header-confirm"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[(_vm.icon === 'ic-warning')?[_c('svg',{staticClass:"warning-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 20 20"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M8.686 2.852L2.127 14.777A1.5 1.5 0 0 0 3.441 17H16.56a1.5 1.5 0 0 0 1.314-2.223L11.314 2.852a1.5 1.5 0 0 0-2.628 0zM10 6.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75zm.75 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0z","fill":"currentColor"}})])])]:[_c('div',{class:_vm.getColor},[_c('i',{class:_vm.getIcon})])],_vm._v(" "),_c('header',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.subContent)?[_c('div',{staticClass:"note-content",domProps:{"innerHTML":_vm._s(_vm.subContent)}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.hasCancel)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.cancel}},[_vm._v("\n                  "+_vm._s(_vm.cancelLabel)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.hasSubmit)?_c('button',{staticClass:"btn btn-primary text-cap",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  "+_vm._s(_vm.submitLabel)+"\n                ")]):_vm._e()])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/job/driver';

/* harmony default export */ __webpack_exports__["a"] = ({
  countAll: function countAll(period, mode) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a
              // .get(endpoint + '/count')
              .get(endpoint + ('/count?period=' + period + '&mode=' + mode)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAll: function getAll(filter) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getDetail: function getDetail(reservationId) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/detail/' + reservationId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  confirmDriver: function confirmDriver(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/driver/confirm', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  declineDriver: function declineDriver(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/driver/decline', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ConfirmModal__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_job_driverJob_inquiryDriverJobService_js__ = __webpack_require__(676);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    confirmModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_ConfirmModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToConfirm: function isAllowToConfirm() {
      return this.allPermissions.includes("Confirm");
    },
    isAllowToDecline: function isAllowToDecline() {
      return this.allPermissions.includes("Decline");
    },
    time: function time() {
      var date = new Date();
      switch (this.period) {
        case "tomorrow":
          date.setDate(date.getDate() + 1);
          break;
        case "next":
          date.setDate(date.getDate() + 2);
          break;
      }
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("dddd, MMMM DD yyyy");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    isShowTripLog: function isShowTripLog() {
      return this.allPermissions.includes("TripLog");
    },
    pickUpDateExpired: function pickUpDateExpired() {
      var _this = this;

      return function (utcPickUpDate) {
        if (_this.userType === "TenantUser") {
          return true;
        } else {
          return _this.$helper.isNotExpiredDate(utcPickUpDate);
        }
      };
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100]
      },
      jobBrowserDateRange: null,
      allPermissions: [],
      defaultPageSize: 0,
      // period: "today",
      period: "today",
      progress: "all",
      items: [{
        reservationId: "3b460f30-86c9-4798-bf30-f9af5f2ca9da",
        code: "OPS202201177EAFC",
        className: "MPV",
        reservationDate: {
          year: 2022,
          month: 1,
          day: 17,
          hour: 14,
          minute: 6,
          second: 15,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Mon, 17 Jan 2022",
          stringMonth: "01",
          stringDate: "17",
          stringHour: "14",
          stringMinute: "06"
        },
        originTimezone: "Asia/Jakarta",
        pickUpDate: {
          year: 2022,
          month: 1,
          day: 17,
          hour: 17,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Mon, 17 Jan 2022",
          stringMonth: "01",
          stringDate: "17",
          stringHour: "17",
          stringMinute: "00"
        },
        dropOffDate: {
          year: 2022,
          month: 1,
          day: 17,
          hour: 17,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Mon, 17 Jan 2022",
          stringMonth: "01",
          stringDate: "17",
          stringHour: "17",
          stringMinute: "00"
        },
        utcPickUpDate: "2022-01-17T10:00:00+00:00",
        utcDropOffDate: "2022-01-17T10:00:00+00:00",
        pickUpLocation: "Soekarno-Hatta International Airport",
        isPickUpAirport: false,
        dropOffLocation: "Gambir Station",
        isDropOffAirport: false,
        companyName: "Root ARRANGGE SG",
        companyPhoneCode: "62",
        companyPhoneNumber: "21234567",
        customerName: "Mr. Aussie",
        customerPhoneCode: "62",
        customerPhoneNumber: "85372828",
        providerName: "Dot Car Rentals",
        driverName: null,
        vehicleFactory: null,
        vehicleBrand: null,
        vehiclePlateNo: null,
        lastState: "Provider Assigned",
        serviceType: "AirportTransfer",
        progress: "Under Review",
        isSelfDrive: false,
        hasProvider: true,
        hasDriver: false,
        hasVehicle: false,
        isTodayBooking: false,
        isTodayPickUp: false,
        isTodayDropOff: false,
        searchMode: "Hybrid",
        queueProgress: null,
        minutePickUpOffsetTime: 0,
        flightEstimatedArrivalTimes: null,
        flightConfirmedTimes: null,
        driverStandbyTime: null
      }, {
        reservationId: "26a30c17-1399-4134-a813-fd6b4ffe3983",
        code: "OPS2022011748C61",
        className: "MPV",
        reservationDate: {
          year: 2022,
          month: 1,
          day: 17,
          hour: 16,
          minute: 50,
          second: 17,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Mon, 17 Jan 2022",
          stringMonth: "01",
          stringDate: "17",
          stringHour: "16",
          stringMinute: "50"
        },
        originTimezone: "Asia/Jakarta",
        pickUpDate: {
          year: 2022,
          month: 1,
          day: 17,
          hour: 18,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Mon, 17 Jan 2022",
          stringMonth: "01",
          stringDate: "17",
          stringHour: "18",
          stringMinute: "00"
        },
        dropOffDate: {
          year: 2022,
          month: 1,
          day: 17,
          hour: 18,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Mon, 17 Jan 2022",
          stringMonth: "01",
          stringDate: "17",
          stringHour: "18",
          stringMinute: "00"
        },
        utcPickUpDate: "2022-01-17T11:00:00+00:00",
        utcDropOffDate: "2022-01-17T11:00:00+00:00",
        pickUpLocation: "Soekarno-Hatta International Airport",
        isPickUpAirport: false,
        dropOffLocation: "Gambir Station",
        isDropOffAirport: false,
        companyName: "Root ARRANGGE SG",
        companyPhoneCode: "62",
        companyPhoneNumber: "21234567",
        customerName: "Mr. Arata",
        customerPhoneCode: "62",
        customerPhoneNumber: "81380558380",
        providerName: "Dot Car Rentals",
        driverName: null,
        vehicleFactory: null,
        vehicleBrand: null,
        vehiclePlateNo: null,
        lastState: "Provider Assigned",
        serviceType: "AirportTransfer",
        progress: "Under Review",
        isSelfDrive: false,
        hasProvider: true,
        hasDriver: false,
        hasVehicle: false,
        isTodayBooking: false,
        isTodayPickUp: false,
        isTodayDropOff: false,
        searchMode: "Hybrid",
        queueProgress: null,
        minutePickUpOffsetTime: 0,
        flightEstimatedArrivalTimes: null,
        flightConfirmedTimes: null,
        driverStandbyTime: null
      }, {
        reservationId: "e15e8440-2088-4629-9b6b-328b0ec6e382",
        code: "OPS20220118B52BF",
        className: "MPV",
        reservationDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 9,
          minute: 43,
          second: 37,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "09",
          stringMinute: "43"
        },
        originTimezone: "Asia/Jakarta",
        pickUpDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 10,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "10",
          stringMinute: "00"
        },
        dropOffDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 10,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "10",
          stringMinute: "00"
        },
        utcPickUpDate: "2022-01-18T03:00:00+00:00",
        utcDropOffDate: "2022-01-18T03:00:00+00:00",
        pickUpLocation: "Soekarno-Hatta International Airport",
        isPickUpAirport: false,
        dropOffLocation: "Gambir Station",
        isDropOffAirport: false,
        companyName: "Root ARRANGGE SG",
        companyPhoneCode: "62",
        companyPhoneNumber: "21234567",
        customerName: "Mr. Arya",
        customerPhoneCode: "62",
        customerPhoneNumber: "81380558380",
        providerName: "(CT Dev) NN Provider Test",
        driverName: null,
        vehicleFactory: null,
        vehicleBrand: null,
        vehiclePlateNo: null,
        lastState: "Provider Assigned",
        serviceType: "AirportTransfer",
        progress: "Under Review",
        isSelfDrive: false,
        hasProvider: true,
        hasDriver: false,
        hasVehicle: false,
        isTodayBooking: false,
        isTodayPickUp: false,
        isTodayDropOff: false,
        searchMode: "Hybrid",
        queueProgress: null,
        minutePickUpOffsetTime: 0,
        flightEstimatedArrivalTimes: null,
        flightConfirmedTimes: null,
        driverStandbyTime: null
      }, {
        reservationId: "e1a53878-f09f-4ec4-a790-b12864b482fd",
        code: "OPS202201186C655",
        className: "MPV",
        reservationDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 8,
          minute: 6,
          second: 58,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "08",
          stringMinute: "06"
        },
        originTimezone: "Asia/Jakarta",
        pickUpDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 10,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "10",
          stringMinute: "00"
        },
        dropOffDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 10,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "10",
          stringMinute: "00"
        },
        utcPickUpDate: "2022-01-18T03:00:00+00:00",
        utcDropOffDate: "2022-01-18T03:00:00+00:00",
        pickUpLocation: "Soekarno-Hatta International Airport",
        isPickUpAirport: false,
        dropOffLocation: "Gambir Station",
        isDropOffAirport: false,
        companyName: "Root ARRANGGE SG",
        companyPhoneCode: "62",
        companyPhoneNumber: "21234567",
        customerName: "Mr. Arya",
        customerPhoneCode: "62",
        customerPhoneNumber: "81380558380",
        providerName: "(CT Dev) NN Provider Test",
        driverName: null,
        vehicleFactory: null,
        vehicleBrand: null,
        vehiclePlateNo: null,
        lastState: "Provider Assigned",
        serviceType: "AirportTransfer",
        progress: "Under Review",
        isSelfDrive: false,
        hasProvider: true,
        hasDriver: false,
        hasVehicle: false,
        isTodayBooking: false,
        isTodayPickUp: false,
        isTodayDropOff: false,
        searchMode: "Hybrid",
        queueProgress: null,
        minutePickUpOffsetTime: 0,
        flightEstimatedArrivalTimes: null,
        flightConfirmedTimes: null,
        driverStandbyTime: null
      }, {
        reservationId: "3ea1db71-0bbc-4a11-bc53-e30571f3887b",
        code: "OPS20220118CEB5D",
        className: "MPV",
        reservationDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 10,
          minute: 5,
          second: 39,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "10",
          stringMinute: "05"
        },
        originTimezone: "Asia/Jakarta",
        pickUpDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 11,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "11",
          stringMinute: "00"
        },
        dropOffDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 11,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "11",
          stringMinute: "00"
        },
        utcPickUpDate: "2022-01-18T04:00:00+00:00",
        utcDropOffDate: "2022-01-18T04:00:00+00:00",
        pickUpLocation: "Soekarno-Hatta International Airport",
        isPickUpAirport: false,
        dropOffLocation: "Gambir Station",
        isDropOffAirport: false,
        companyName: "Root ARRANGGE SG",
        companyPhoneCode: "62",
        companyPhoneNumber: "21234567",
        customerName: "Mr. Arya",
        customerPhoneCode: "62",
        customerPhoneNumber: "81380558380",
        providerName: "(CT Dev) NN Provider Test",
        driverName: null,
        vehicleFactory: null,
        vehicleBrand: null,
        vehiclePlateNo: null,
        lastState: "Provider Assigned",
        serviceType: "AirportTransfer",
        progress: "Under Review",
        isSelfDrive: false,
        hasProvider: true,
        hasDriver: false,
        hasVehicle: false,
        isTodayBooking: false,
        isTodayPickUp: false,
        isTodayDropOff: false,
        searchMode: "Hybrid",
        queueProgress: null,
        minutePickUpOffsetTime: 0,
        flightEstimatedArrivalTimes: null,
        flightConfirmedTimes: null,
        driverStandbyTime: null
      }, {
        reservationId: "b97f2458-647c-4674-a428-bbbb8444834d",
        code: "OPS20220118A5670",
        className: "MPV",
        reservationDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 10,
          minute: 13,
          second: 54,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "10",
          stringMinute: "13"
        },
        originTimezone: "Asia/Jakarta",
        pickUpDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 11,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "11",
          stringMinute: "00"
        },
        dropOffDate: {
          year: 2022,
          month: 1,
          day: 18,
          hour: 11,
          minute: 0,
          second: 0,
          offsetName: "UTC+07:00",
          stringShortMonth: "Jan",
          stringFullDate: "Tue, 18 Jan 2022",
          stringMonth: "01",
          stringDate: "18",
          stringHour: "11",
          stringMinute: "00"
        },
        utcPickUpDate: "2022-01-18T04:00:00+00:00",
        utcDropOffDate: "2022-01-18T04:00:00+00:00",
        pickUpLocation: "Soekarno-Hatta International Airport",
        isPickUpAirport: false,
        dropOffLocation: "Gambir Station",
        isDropOffAirport: false,
        companyName: "Root ARRANGGE SG",
        companyPhoneCode: "62",
        companyPhoneNumber: "21234567",
        customerName: "Mr. Arya",
        customerPhoneCode: "62",
        customerPhoneNumber: "81380558380",
        providerName: "(CT Dev) NN Provider Test",
        driverName: null,
        vehicleFactory: null,
        vehicleBrand: null,
        vehiclePlateNo: null,
        lastState: "Provider Assigned",
        serviceType: "AirportTransfer",
        progress: "Under Review",
        isSelfDrive: false,
        hasProvider: true,
        hasDriver: false,
        hasVehicle: false,
        isTodayBooking: false,
        isTodayPickUp: false,
        isTodayDropOff: false,
        searchMode: "Hybrid",
        queueProgress: null,
        minutePickUpOffsetTime: 0,
        flightEstimatedArrivalTimes: null,
        flightConfirmedTimes: null,
        driverStandbyTime: null
      }],
      totalAllJobs: 0,
      totalJobsOpen: 0,
      totalJobsRun: 0,
      totalJobsUnderReview: 0,
      totalJobsDone: 0,
      totalJobsClose: 0,
      totalJobsAborted: 0,
      totalJobsRescued: 0,
      isLoading: false,
      msg: "Please wait",
      selectedDriverJob: {},
      userType: "Unspecified"
    };
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.$helper.scrollTop();
              _context.next = 3;
              return _this2.getUserType();

            case 3:
              _context.next = 5;
              return _this2.$store.dispatch("setting/getAllPublic");

            case 5:
              publicSettings = _context.sent;

              _this2.table.pageSize = _this2.$helper.extractSetting(publicSettings, "PageSize", 25);
              _this2.defaultPageSize = _this2.table.pageSize;

              _context.next = 10;
              return _this2.$store.dispatch("user/getProfile");

            case 10:
              profile = _context.sent;
              permissions = profile.services[_this2.$route.name];

              if (permissions) {
                _this2.allPermissions = permissions;
              }

              if (!_this2.isAllowToRead) {
                _context.next = 16;
                break;
              }

              _context.next = 16;
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this2.countAll(), _this2.getAll(_this2.period, _this2.progress)]);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("driver-job-browser-link");
    $("#jobBrowserDateRange-input").addClass("borderless-jobBrowserDateRange");
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.table.pageNumber = 1;
                _context2.next = 3;
                return _this3.getAll(_this3.period, _this3.progress);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this4;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll(self.period, self.progress);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this5.getAll(_this5.period, _this5.progress);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getUserType: function getUserType() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var profile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.$store.dispatch("user/getProfile");

              case 2:
                profile = _context6.sent;

                _this6.userType = profile.userType;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    isAirportTransfer: function isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    openConfirmationDialog: function openConfirmationDialog(item) {
      this.selectedDriverJob = item;
      $("#DriverConfirmation").modal({ backdrop: "static", keyboard: false });
    },
    openDeclineDialog: function openDeclineDialog(item) {
      this.selectedDriverJob = item;
      $("#DriverDeclineConfirmation").modal({
        backdrop: "static",
        keyboard: false
      });
    },
    changeProgress: function changeProgress(progress) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.table.keyword = "";
                _this7.table.pageNumber = 1;
                _this7.table.pageSize = _this7.defaultPageSize;
                _this7.progress = progress;
                _context7.next = 6;
                return _this7.getAll(_this7.period, _this7.progress);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    changePeriods: function changePeriods(period) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.period = period;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this8.countAll(), _this8.getAll(_this8.period, _this8.progress, true)]);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    getAll: function getAll(period, progress) {
      var _this9 = this;

      var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (_this9.isAllowToRead) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _context9.prev = 2;

                if (clear) _this9.table.pageNumber = 1;
                _this9.isLoading = true;
                _this9.items = [];
                _this9.period = period;
                _this9.progress = progress;
                filter = "?page=" + _this9.table.pageNumber + "&size=" + _this9.table.pageSize;

                if (_this9.table.keyword !== null && _this9.table.keyword !== "") {
                  filter += "&search=" + _this9.table.keyword;
                }
                filter += "&data=" + _this9.progress + ";0;" + _this9.convertPeriod();
                _context9.next = 13;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_driverJob_inquiryDriverJobService_js__["a" /* default */].getAll(filter);

              case 13:
                response = _context9.sent;

                _this9.items = response.data;
                _this9.table.totalPages = response.totalPages;
                _this9.table.totalRecords = response.totalRecords;
                _context9.next = 22;
                break;

              case 19:
                _context9.prev = 19;
                _context9.t0 = _context9["catch"](2);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this9.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 22:
                _context9.prev = 22;

                _this9.isLoading = false;
                return _context9.finish(22);

              case 25:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[2, 19, 22, 25]]);
      }))();
    },
    countAll: function countAll() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_driverJob_inquiryDriverJobService_js__["a" /* default */].countAll(_this10.convertPeriod(), 0);

              case 3:
                response = _context10.sent;

                _this10.totalAllJobs = response.data.totalAllJobs;
                _this10.totalJobsOpen = response.data.totalJobsOpen;
                _this10.totalJobsRun = response.data.totalJobsRun;
                _this10.totalJobsUnderReview = response.data.totalJobsUnderReview;
                _this10.totalJobsDone = response.data.totalJobsDone;
                _this10.totalJobsClose = response.data.totalJobsClose;
                _this10.totalJobsAborted = response.data.totalJobsAborted;
                _this10.totalJobsRescued = response.data.totalJobsRescued;
                _context10.next = 17;
                break;

              case 14:
                _context10.prev = 14;
                _context10.t0 = _context10["catch"](0);

                if (_context10.t0.errors) {
                  for (index = 0; index < _context10.t0.errors.length; index++) {
                    _this10.$notification.error(_context10.t0.errors[index], { title: "Error" });
                  }
                }

              case 17:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[0, 14]]);
      }))();
    },
    confirmDriver: function confirmDriver() {
      var _this11 = this;

      var overrideTimingBlock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this11.isLoading = true;

                _context12.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_driverJob_inquiryDriverJobService_js__["a" /* default */].confirmDriver({
                  reservationId: _this11.selectedDriverJob.reservationId,
                  driverId: _this11.selectedDriverJob.driverId,
                  overrideTimingBlock: overrideTimingBlock
                });

              case 4:

                setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          _context11.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this11.countAll(), _this11.getAll(_this11.period, _this11.progress)]);

                        case 2:
                          _this11.isLoading = false;
                          $(_this11.$refs.provider_driverjob_modal).modal("hide");
                          _this11.$notification.success("Successfully confirmed.", {
                            title: "Success"
                          });

                        case 5:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11, _this11);
                })), 1000);
                _context12.next = 11;
                break;

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12["catch"](0);

                if (_this11.userType === "TenantUser" && _context12.t0.errors[0].includes("JTB001|")) {
                  $("#OverrideConfirmDriver").modal({
                    backdrop: "static",
                    keyboard: false
                  });
                } else {
                  if (_context12.t0.errors) {
                    for (index = 0; index < _context12.t0.errors.length; index++) {
                      _this11.$notification.error(_context12.t0.errors[index], { title: "Error" });
                    }
                  }
                }
                _this11.isLoading = false;

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this11, [[0, 7]]);
      }))();
    },
    declineDriver: function declineDriver() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                _this12.isLoading = true;

                _context14.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_driverJob_inquiryDriverJobService_js__["a" /* default */].declineDriver({
                  reservationId: _this12.selectedDriverJob.reservationId,
                  driverId: _this12.selectedDriverJob.driverId
                });

              case 4:

                setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          _context13.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this12.countAll(), _this12.getAll(_this12.period, _this12.progress)]);

                        case 2:
                          _this12.isLoading = false;
                          $(_this12.$refs.provider_driverjob_modal).modal("hide");
                          _this12.$notification.success("Successfully declined.", {
                            title: "Success"
                          });

                        case 5:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13, _this12);
                })), 1000);
                _context14.next = 10;
                break;

              case 7:
                _context14.prev = 7;
                _context14.t0 = _context14["catch"](0);

                if (_context14.t0.errors) {
                  for (index = 0; index < _context14.t0.errors.length; index++) {
                    _this12.$notification.error(_context14.t0.errors[index], { title: "Error" });
                  }
                }

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this12, [[0, 7]]);
      }))();
    },
    convertPeriod: function convertPeriod() {
      var result = "";
      var date = new Date();
      switch (this.period.toLowerCase()) {
        case "all":
          this.jobBrowserDateRange = null;
          result = "all";
          break;
        case "today":
          this.jobBrowserDateRange = null;
          result = "today_" + date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          break;
        case "tomorrow":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 1);
          result = "tomorrow_" + date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          break;
        case "next":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 2);
          result = "next_" + date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          break;
        case "range":
          result = "range_" + this.jobBrowserDateRange.start + "_" + this.jobBrowserDateRange.end;
          break;
      }
      return result;
    },
    getLastState: function getLastState(item) {
      if (item.hasDriver && item.hasVehicle) {
        return "Driver & Vehicle Assigned";
      } else {
        return item.lastState;
      }
    },
    shortenString: function shortenString(item, textToBeReplaced) {
      return item.replace(textToBeReplaced, "");
    },
    showPicker: function showPicker() {
      $(".tabs-inquiry").removeClass("sticky");
    },
    hidePicker: function hidePicker() {
      $(".tabs-inquiry").addClass("sticky");
    },
    searchRange: function searchRange() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!_this13.jobBrowserDateRange.start || _this13.jobBrowserDateRange.start === "" || !_this13.jobBrowserDateRange.end || _this13.jobBrowserDateRange.end === "")) {
                  _context15.next = 3;
                  break;
                }

                alert("Please select a date range.");
                return _context15.abrupt("return");

              case 3:
                _this13.hidePicker();
                _context15.next = 6;
                return _this13.changePeriods("range");

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this13);
      }))();
    }
  }
});

/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info middle-content"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Driver Jobs Inquiry")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"data-row --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.time))])]),_vm._v(" "),_c('div',{staticClass:"form-group mt-20"},[_c('div',{staticClass:"btn-group btn-group-toggle mb-25",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'all' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('all')}}},[_vm._v("\n                All\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'today' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('today')}}},[_vm._v("\n                Today\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'tomorrow' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('tomorrow')}}},[_vm._v("\n                Tomorrow\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'next' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('next')}}},[_vm._v("\n                Next Day\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-selectDate",class:{ 'btn-active': _vm.period === 'range' },attrs:{"type":"button"}},[_c('VueCtkDateTimePicker',{attrs:{"id":"jobBrowserDateRange","name":"jobBrowserDateRange","color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","range":"","no-shortcuts":"","label":"Select Date","no-header":"","overlay":"","no-button-now":"","button-color":"#FFB733","no-clear-button":""},on:{"is-shown":function($event){return _vm.showPicker()},"is-hidden":function($event){return _vm.hidePicker()},"validate":function($event){return _vm.searchRange()}},model:{value:(_vm.jobBrowserDateRange),callback:function ($$v) {_vm.jobBrowserDateRange=$$v},expression:"jobBrowserDateRange"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Reservation Code"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('ul',{staticClass:"nav nav-tabs tabs-inquiry sticky"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"data-toggle":"tab","href":"#job-all"},on:{"click":function($event){return _vm.changeProgress('all')}}},[_c('span',{staticClass:"qty-jobs"},[_vm._v(_vm._s(_vm.totalAllJobs))]),_vm._v(" All\n              ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"data-toggle":"tab","href":"#job-open"},on:{"click":function($event){return _vm.changeProgress('open')}}},[_c('span',{staticClass:"qty-jobs"},[_vm._v(_vm._s(_vm.totalJobsOpen))]),_vm._v(" Open\n              ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"data-toggle":"tab","href":"#job-run"},on:{"click":function($event){return _vm.changeProgress('run')}}},[_c('span',{staticClass:"qty-jobs"},[_vm._v(_vm._s(_vm.totalJobsRun))]),_vm._v(" Run\n              ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"data-toggle":"tab","href":"#job-under-review"},on:{"click":function($event){return _vm.changeProgress('underreview')}}},[_c('span',{staticClass:"qty-jobs"},[_vm._v(_vm._s(_vm.totalJobsUnderReview))]),_vm._v(" Under\n                Review\n              ")])]),_vm._v(" "),_c('li',{staticClass:"hidden"},[_c('a',{attrs:{"data-toggle":"tab","href":"#job-rescue"},on:{"click":function($event){return _vm.changeProgress('rescueoperation')}}},[_c('span',{staticClass:"qty-jobs"},[_vm._v(_vm._s(_vm.totalJobsRescued))]),_vm._v(" Rescue\n              ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"data-toggle":"tab","href":"#job-done"},on:{"click":function($event){return _vm.changeProgress('done')}}},[_c('span',{staticClass:"qty-jobs"},[_vm._v(_vm._s(_vm.totalJobsDone))]),_vm._v(" Done\n              ")])]),_vm._v(" "),_c('li',{staticClass:"hidden"},[_c('a',{attrs:{"data-toggle":"tab","href":"#job-close"},on:{"click":function($event){return _vm.changeProgress('close')}}},[_c('span',{staticClass:"qty-jobs"},[_vm._v(_vm._s(_vm.totalJobsClose))]),_vm._v(" Closed\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"job-all"}},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.reservationId,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isPickUpAirport
                            )?_c('i',{staticClass:"ic-flight-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              !item.isPickUpAirport &&
                              !item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          "+_vm._s(item.providerName)+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          ("+_vm._s(item.driverName)+")\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"pos-rel text-center"},[_c('span',{class:{
                            'sts_job-open': item.progress === 'Open',
                            'sts_job-run': item.progress === 'Run',
                            'sts_job-done': item.progress === 'Done',
                            'sts_job-closed': item.progress === 'Close',
                            'sts_job-aborted': item.progress === 'Abort',
                            'sts_job-rescue_operation':
                              item.progress === 'RescueOperation',
                          }}),_vm._v(" "),(item.workflowControl)?[_c('span',{class:item.workflowControl.indicator === 1
                                ? 'green-job mt-5'
                                : item.workflowControl.indicator === 2
                                ? 'yellow-job mt-5'
                                : item.workflowControl.indicator === 3
                                ? 'red-job mt-5'
                                : 'last_state d-flex justify-center items-center gap-5'},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(item.workflowControl.lastStateDescription))])])]:[_c('span',{staticClass:"last_state d-flex justify-center items-center gap-5"},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(_vm.getLastState(item)))])])],_vm._v(" "),(_vm.isAllowToRead)?_c('div',{staticClass:"row-big-menu"},[_c('ul',[(_vm.isAllowToRead)?_c('li',[_c('router-link',{staticClass:"sts-warning btn btn-default",attrs:{"to":("/job/driver/" + (item.reservationId)),"target":"_blank"}},[_vm._v("\n                                Details\n                              ")])],1):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.customerName))]),_vm._v("\n                        "+_vm._s(_vm.userType === "ProviderUser"
                            ? ("+" + (item.customerPhoneCode) + " " + (item.customerPhoneNumber))
                            : item.companyName)+"\n                      ")]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.className))]),_vm._v(" "),(item.hasVehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                            "+_vm._s(item.vehicleFactory)+" "+_vm._s(item.vehicleBrand)+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                            ("+_vm._s(item.vehiclePlateNo)+")\n                          ")])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.pickUpDate.stringDate)+"\n                          "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                          "+_vm._s(item.pickUpDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pickUpLocation))])]),_vm._v(" "),_c('td',[(item.isTodayDropOff)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.dropOffDate.stringDate)+"\n                          "+_vm._s(item.dropOffDate.stringShortMonth)+"\n                          "+_vm._s(item.dropOffDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.dropOffDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.dropOffDate.stringHour)+":"+_vm._s(item.dropOffDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.dropOffLocation))])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"job-under-review"}},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.reservationId,staticClass:"detail-row"},[_c('td',[_c('strong',[_vm._v(_vm._s(item.code))]),_vm._v(" "),(item.hasProvider)?_c('span',{staticClass:"new-line"},[_vm._v("\n                          "+_vm._s(item.providerName)+"\n                        ")]):_vm._e(),_vm._v(" "),(item.hasDriver)?_c('span',{staticClass:"new-line"},[_vm._v("\n                          ("+_vm._s(item.driverName)+")\n                        ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{class:{
                            'sts_job-open': item.progress === 'Open',
                            'sts_job-run': item.progress === 'Run',
                            'sts_job-done': item.progress === 'Done',
                            'sts_job-closed': item.progress === 'Close',
                            'sts_job-aborted': item.progress === 'Abort',
                            'sts_job-rescue_operation':
                              item.progress === 'RescueOperation',
                            'sts_job-under-review':
                              item.progress === 'UnderReview',
                          }})]),_vm._v(" "),_c('td',{staticClass:"pos-rel"},[_c('strong',[_vm._v(_vm._s(item.customerName))]),_vm._v("\n                        "+_vm._s(item.companyName)+"\n                      ")]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.className))]),_vm._v(" "),(item.hasVehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                            "+_vm._s(item.vehicleFactory)+" "+_vm._s(item.vehicleBrand)+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                            ("+_vm._s(item.vehiclePlateNo)+")\n                          ")])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.pickUpDate.stringDate)+"\n                          "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                          "+_vm._s(item.pickUpDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pickUpLocation))])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"job-open"}},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.reservationId,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isPickUpAirport
                            )?_c('i',{staticClass:"ic-flight-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              !item.isPickUpAirport &&
                              !item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          "+_vm._s(item.providerName)+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          ("+_vm._s(item.driverName)+")\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"pos-rel text-center"},[(item.workflowControl)?[_c('span',{class:item.workflowControl.indicator === 1
                                ? 'green-job mt-5'
                                : item.workflowControl.indicator === 2
                                ? 'yellow-job mt-5'
                                : item.workflowControl.indicator === 3
                                ? 'red-job mt-5'
                                : 'last_state d-flex justify-center items-center gap-5'},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(item.workflowControl.lastStateDescription))])])]:[_c('span',{staticClass:"last_state d-flex justify-center items-center gap-5"},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(_vm.getLastState(item)))])])],_vm._v(" "),(
                            ((_vm.isAllowToConfirm || _vm.isAllowToDecline) &&
                              _vm.$helper.isNotExpiredDate(item.utcPickUpDate)) ||
                            _vm.isAllowToRead
                          )?_c('div',{staticClass:"row-big-menu"},[_c('ul',[(
                                item.isOwnInventory &&
                                item.lastState !== 'Driver Confirmed' &&
                                _vm.pickUpDateExpired(item.utcPickUpDate) &&
                                _vm.isAllowToConfirm
                              )?_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.openConfirmationDialog(item)}}},[_c('span',[_vm._v("Confirm")])])]):_vm._e(),_vm._v(" "),(
                                item.isOwnInventory &&
                                _vm.isAllowToDecline &&
                                _vm.$helper.isNotExpiredDate(item.utcPickUpDate)
                              )?_c('li',[_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.openDeclineDialog(item)}}},[_c('span',[_vm._v("Decline")])])]):_vm._e(),_vm._v(" "),(_vm.isAllowToRead)?_c('li',[_c('router-link',{staticClass:"sts-warning btn btn-default",attrs:{"to":("/job/driver/" + (item.reservationId)),"target":"_blank"}},[_vm._v("\n                                Details\n                              ")])],1):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.customerName))]),_vm._v("\n                        "+_vm._s(_vm.userType === "ProviderUser"
                            ? ("+" + (item.customerPhoneCode) + " " + (item.customerPhoneNumber))
                            : item.companyName)+"\n                      ")]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.className))]),_vm._v(" "),(item.hasVehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                            "+_vm._s(item.vehicleFactory)+" "+_vm._s(item.vehicleBrand)+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                            ("+_vm._s(item.vehiclePlateNo)+")\n                          ")])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.pickUpDate.stringDate)+"\n                          "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                          "+_vm._s(item.pickUpDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pickUpLocation))])]),_vm._v(" "),_c('td',[(item.isTodayDropOff)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.dropOffDate.stringDate)+"\n                          "+_vm._s(item.dropOffDate.stringShortMonth)+"\n                          "+_vm._s(item.dropOffDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.dropOffDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.dropOffDate.stringHour)+":"+_vm._s(item.dropOffDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.dropOffLocation))])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"job-run"}},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.reservationId,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isPickUpAirport
                            )?_c('i',{staticClass:"ic-flight-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              !item.isPickUpAirport &&
                              !item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          "+_vm._s(item.providerName)+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          ("+_vm._s(item.driverName)+")\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"pos-rel text-center"},[(item.workflowControl)?[_c('span',{class:item.workflowControl.indicator === 1
                                ? 'green-job mt-5'
                                : item.workflowControl.indicator === 2
                                ? 'yellow-job mt-5'
                                : item.workflowControl.indicator === 3
                                ? 'red-job mt-5'
                                : 'last_state d-flex justify-center items-center gap-5'},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(item.workflowControl.lastStateDescription))])])]:[_c('span',{staticClass:"last_state d-flex justify-center items-center gap-5"},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(_vm.getLastState(item)))])])],_vm._v(" "),(
                            (_vm.isAllowToConfirm &&
                              _vm.$helper.isNotExpiredDate(item.utcPickUpDate)) ||
                            _vm.isAllowToRead
                          )?_c('div',{staticClass:"row-big-menu"},[_c('ul',[(_vm.isAllowToRead)?_c('li',[_c('router-link',{staticClass:"sts-warning btn btn-default",attrs:{"to":("/job/driver/" + (item.reservationId)),"target":"_blank"}},[_vm._v("\n                                Details\n                              ")])],1):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.customerName))]),_vm._v("\n                        "+_vm._s(_vm.userType === "ProviderUser"
                            ? ("+" + (item.customerPhoneCode) + " " + (item.customerPhoneNumber))
                            : item.companyName)+"\n                      ")]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.className))]),_vm._v(" "),(item.hasVehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                            "+_vm._s(item.vehicleFactory)+" "+_vm._s(item.vehicleBrand)+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                            ("+_vm._s(item.vehiclePlateNo)+")\n                          ")])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.pickUpDate.stringDate)+"\n                          "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                          "+_vm._s(item.pickUpDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pickUpLocation))])]),_vm._v(" "),_c('td',[(item.isTodayDropOff)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.dropOffDate.stringDate)+"\n                          "+_vm._s(item.dropOffDate.stringShortMonth)+"\n                          "+_vm._s(item.dropOffDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.dropOffDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.dropOffDate.stringHour)+":"+_vm._s(item.dropOffDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.dropOffLocation))])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"job-rescue"}},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(5),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.reservationId,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isPickUpAirport
                            )?_c('i',{staticClass:"ic-flight-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              !item.isPickUpAirport &&
                              !item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          "+_vm._s(item.providerName)+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          ("+_vm._s(item.driverName)+")\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"pos-rel text-center"},[(item.workflowControl)?[_c('span',{class:item.workflowControl.indicator === 1
                                ? 'green-job mt-5'
                                : item.workflowControl.indicator === 2
                                ? 'yellow-job mt-5'
                                : item.workflowControl.indicator === 3
                                ? 'red-job mt-5'
                                : 'last_state d-flex justify-center items-center gap-5'},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(item.workflowControl.lastStateDescription))])])]:[_c('span',{staticClass:"last_state d-flex justify-center items-center gap-5"},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(_vm.getLastState(item)))])])],_vm._v(" "),(_vm.isAllowToRead)?_c('div',{staticClass:"row-big-menu"},[_c('ul',[(_vm.isAllowToRead)?_c('li',[_c('router-link',{staticClass:"sts-warning btn btn-default",attrs:{"to":("/job/driver/" + (item.reservationId)),"target":"_blank"}},[_vm._v("\n                                Details\n                              ")])],1):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.customerName))]),_vm._v("\n                        "+_vm._s(_vm.userType === "ProviderUser"
                            ? ("+" + (item.customerPhoneCode) + " " + (item.customerPhoneNumber))
                            : item.companyName)+"\n                      ")]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.className))]),_vm._v(" "),(item.hasVehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                            "+_vm._s(item.vehicleFactory)+" "+_vm._s(item.vehicleBrand)+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                            ("+_vm._s(item.vehiclePlateNo)+")\n                          ")])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.pickUpDate.stringDate)+"\n                          "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                          "+_vm._s(item.pickUpDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pickUpLocation))])]),_vm._v(" "),_c('td',[(item.isTodayDropOff)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.dropOffDate.stringDate)+"\n                          "+_vm._s(item.dropOffDate.stringShortMonth)+"\n                          "+_vm._s(item.dropOffDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.dropOffDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.dropOffDate.stringHour)+":"+_vm._s(item.dropOffDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.dropOffLocation))])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"job-done"}},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(6),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.reservationId,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isPickUpAirport
                            )?_c('i',{staticClass:"ic-flight-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              !item.isPickUpAirport &&
                              !item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          "+_vm._s(item.providerName)+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          ("+_vm._s(item.driverName)+")\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"pos-rel text-center"},[(item.workflowControl)?[_c('span',{class:item.workflowControl.indicator === 1
                                ? 'green-job mt-5'
                                : item.workflowControl.indicator === 2
                                ? 'yellow-job mt-5'
                                : item.workflowControl.indicator === 3
                                ? 'red-job mt-5'
                                : 'last_state d-flex justify-center items-center gap-5'},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(item.workflowControl.lastStateDescription))])])]:[_c('span',{staticClass:"last_state d-flex justify-center items-center gap-5"},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(_vm.getLastState(item)))])])],_vm._v(" "),(_vm.isAllowToRead)?_c('div',{staticClass:"row-big-menu"},[_c('ul',[(_vm.isAllowToRead)?_c('li',[_c('router-link',{staticClass:"sts-warning btn btn-default",attrs:{"to":("/job/driver/" + (item.reservationId)),"target":"_blank"}},[_vm._v("\n                                Details\n                              ")])],1):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.customerName))]),_vm._v("\n                        "+_vm._s(_vm.userType === "ProviderUser"
                            ? ("+" + (item.customerPhoneCode) + " " + (item.customerPhoneNumber))
                            : item.companyName)+"\n                      ")]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.className))]),_vm._v(" "),(item.hasVehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                            "+_vm._s(item.vehicleFactory)+" "+_vm._s(item.vehicleBrand)+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                            ("+_vm._s(item.vehiclePlateNo)+")\n                          ")])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.pickUpDate.stringDate)+"\n                          "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                          "+_vm._s(item.pickUpDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pickUpLocation))])]),_vm._v(" "),_c('td',[(item.isTodayDropOff)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.dropOffDate.stringDate)+"\n                          "+_vm._s(item.dropOffDate.stringShortMonth)+"\n                          "+_vm._s(item.dropOffDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.dropOffDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.dropOffDate.stringHour)+":"+_vm._s(item.dropOffDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.dropOffLocation))])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"job-close"}},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(7),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.reservationId,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isPickUpAirport
                            )?_c('i',{staticClass:"ic-flight-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                              _vm.isAirportTransfer(item.serviceType) &&
                              !item.isPickUpAirport &&
                              !item.isDropOffAirport
                            )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          "+_vm._s(item.providerName)+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                          ("+_vm._s(item.driverName)+")\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"pos-rel text-center"},[(item.workflowControl)?[_c('span',{class:item.workflowControl.indicator === 1
                                ? 'green-job mt-5'
                                : item.workflowControl.indicator === 2
                                ? 'yellow-job mt-5'
                                : item.workflowControl.indicator === 3
                                ? 'red-job mt-5'
                                : 'last_state d-flex justify-center items-center gap-5'},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(item.workflowControl.lastStateDescription))])])]:[_c('span',{staticClass:"last_state d-flex justify-center items-center gap-5"},[_c('i',{staticClass:"ic-checklist"}),_vm._v(" "),(item.progress === 'RescueOperation')?_c('span',[_vm._v("\n                              "+_vm._s(_vm.shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                ))+"\n                            ")]):_c('span',{staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(_vm.getLastState(item)))])])],_vm._v(" "),(_vm.isAllowToRead)?_c('div',{staticClass:"row-big-menu"},[_c('ul',[(_vm.isAllowToRead)?_c('li',[_c('router-link',{staticClass:"sts-warning btn btn-default",attrs:{"to":("/job/driver/" + (item.reservationId)),"target":"_blank"}},[_vm._v("\n                                Details\n                              ")])],1):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.customerName))]),_vm._v("\n                        "+_vm._s(_vm.userType === "ProviderUser"
                            ? ("+" + (item.customerPhoneCode) + " " + (item.customerPhoneNumber))
                            : item.companyName)+"\n                      ")]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.className))]),_vm._v(" "),(item.hasVehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                            "+_vm._s(item.vehicleFactory)+" "+_vm._s(item.vehicleBrand)+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                            ("+_vm._s(item.vehiclePlateNo)+")\n                          ")])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.pickUpDate.stringDate)+"\n                          "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                          "+_vm._s(item.pickUpDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.pickUpLocation))])]),_vm._v(" "),_c('td',[(item.isTodayDropOff)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                          "+_vm._s(item.dropOffDate.stringDate)+"\n                          "+_vm._s(item.dropOffDate.stringShortMonth)+"\n                          "+_vm._s(item.dropOffDate.year)+"\n                        ")]):_c('span',[_vm._v(_vm._s(item.dropOffDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                          "+_vm._s(item.dropOffDate.stringHour)+":"+_vm._s(item.dropOffDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.dropOffLocation))])])])}),0)])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('confirmModal',{attrs:{"id":'DriverConfirmation',"header":'Confirm',"content":"Are you sure you want confirm this job?","cancel-label":'Cancel',"submit-label":'Yes, Confirm',"color":'confirm-icon',"icon":'ic-check'},on:{"submit":_vm.confirmDriver}}),_vm._v(" "),_c('confirmModal',{attrs:{"id":'OverrideConfirmDriver',"header":'Potential Job Conflict',"content":"This driver has another assignment that may overlap this job. Are you sure you wish to proceed?","cancel-label":'No',"submit-label":'Yes',"color":'confirm-icon',"icon":'ic-warning'},on:{"submit":function($event){return _vm.confirmDriver(true)}}}),_vm._v(" "),_c('confirmModal',{attrs:{"id":'DriverDeclineConfirmation',"header":'Decline',"content":"Are you sure you want decline this job?","cancel-label":'Cancel',"submit-label":'Yes, Decline',"color":'delete-icon',"icon":'ic-close'},on:{"submit":_vm.declineDriver}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-legend"},[_c('ul',[_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code & Driver")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Drop-Off")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Code & Provider")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Progress & Status")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code & Driver")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Drop-Off")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code & Driver")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Drop-Off")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code & Driver")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Drop-Off")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code & Driver")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Drop-Off")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code & Driver")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Drop-Off")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/61.f58dcb941d55f0401a19.js